var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownButtonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1164_891)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1164_891",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16C8 11.5817 11.5817 8 16 8H34C38.4183 8 42 11.5817 42 16V34C42 38.4183 38.4183 42 34 42H16C11.5817 42 8 38.4183 8 34V16Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8 16C8 11.5817 11.5817 8 16 8H34C38.4183 8 42 11.5817 42 16V34C42 38.4183 38.4183 42 34 42H16C11.5817 42 8 38.4183 8 34V16Z",
    fill: "#0E0F10",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_diamond_1164_891_clip_path)",
    "data-figma-skip-parse": "true",
    mask: "url(#path-1-inside-1_1164_891)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.017 -0.017 0 25 25)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1058.82,
    height: 1058.82,
    fill: "url(#paint0_diamond_1164_891)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1058.82,
    height: 1058.82,
    transform: "scale(1 -1)",
    fill: "url(#paint0_diamond_1164_891)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1058.82,
    height: 1058.82,
    transform: "scale(-1 1)",
    fill: "url(#paint0_diamond_1164_891)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1058.82,
    height: 1058.82,
    transform: "scale(-1)",
    fill: "url(#paint0_diamond_1164_891)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M16 8V9H34V8V7H16V8ZM42 16H41V34H42H43V16H42ZM34 42V41H16V42V43H34V42ZM8 34H9V16H8H7V34H8ZM16 42V41C12.134 41 9 37.866 9 34H8H7C7 38.9706 11.0294 43 16 43V42ZM42 34H41C41 37.866 37.866 41 34 41V42V43C38.9706 43 43 38.9706 43 34H42ZM34 8V9C37.866 9 41 12.134 41 16H42H43C43 11.0294 38.9706 7 34 7V8ZM16 8V7C11.0294 7 7 11.0294 7 16H8H9C9 12.134 12.134 9 16 9V8Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":0.29411765933036804,\"b\":0.29411765933036804,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":0.47843137383460999,\"b\":0.0,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":1.0,\"g\":0.29411765933036804,\"b\":0.29411765933036804,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":0.47843137383460999,\"b\":0.0,\"a\":0.0},\"position\":1.0}],\"transform\":{\"m00\":2.0818996229250058e-15,\"m01\":-34.0,\"m02\":42.0,\"m10\":34.0,\"m11\":2.0818996229250058e-15,\"m12\":8.0},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}",
    mask: "url(#path-1-inside-1_1164_891)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4604 26.523L25.3979 31.5855C25.3457 31.6378 25.2836 31.6793 25.2154 31.7076C25.1471 31.7359 25.0739 31.7504 24.9999 31.7504C24.926 31.7504 24.8528 31.7359 24.7845 31.7076C24.7163 31.6793 24.6542 31.6378 24.602 31.5855L19.5395 26.523C19.4339 26.4174 19.3746 26.2743 19.3746 26.125C19.3746 25.9757 19.4339 25.8326 19.5395 25.727C19.645 25.6215 19.7882 25.5622 19.9374 25.5622C20.0867 25.5622 20.2299 25.6215 20.3354 25.727L24.4374 29.8298V18.8125C24.4374 18.6633 24.4967 18.5202 24.6022 18.4148C24.7077 18.3093 24.8508 18.25 24.9999 18.25C25.1491 18.25 25.2922 18.3093 25.3977 18.4148C25.5032 18.5202 25.5624 18.6633 25.5624 18.8125V29.8298L29.6645 25.727C29.77 25.6215 29.9132 25.5622 30.0624 25.5622C30.2117 25.5622 30.3549 25.6215 30.4604 25.727C30.566 25.8326 30.6253 25.9757 30.6253 26.125C30.6253 26.2743 30.566 26.4174 30.4604 26.523Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1164_891",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.52549 0 0 0 0 0.231373 0 0 0 0 0.0235294 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1164_891"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1164_891",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_diamond_1164_891_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8V9H34V8V7H16V8ZM42 16H41V34H42H43V16H42ZM34 42V41H16V42V43H34V42ZM8 34H9V16H8H7V34H8ZM16 42V41C12.134 41 9 37.866 9 34H8H7C7 38.9706 11.0294 43 16 43V42ZM42 34H41C41 37.866 37.866 41 34 41V42V43C38.9706 43 43 38.9706 43 34H42ZM34 8V9C37.866 9 41 12.134 41 16H42H43C43 11.0294 38.9706 7 34 7V8ZM16 8V7C11.0294 7 7 11.0294 7 16H8H9C9 12.134 12.134 9 16 9V8Z",
    mask: "url(#path-1-inside-1_1164_891)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_diamond_1164_891",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A00",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownButtonIcon);
export default __webpack_public_path__ + "static/media/arrow-down-button-icon.d155c2566feca10e5f6d137f01134b77.svg";
export { ForwardRef as ReactComponent };